import React from 'react'

export const IconSuccess = () => {
  return <img src="https://icongr.am/clarity/check.svg?size=24&amp;color=14854f" alt="icon" />
}
